<template>
  <div class="dayControl " :class="{dayControl2:!isMini}">
      <div class="line-box">
        <div
          v-for="(item, index) in timeTypeArray"
          :key="index"
          :class=" ['cbtn',curTimeType == item.type ? ' cbtnSelected' : '']
          "
          @click="refreshType(item.type)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="timeLabel flex" @click="showDatePicker" >
         <div class="icon-wrap"  :class="{'icon-wrap-active':curTimeType == ''}">
            <span>范围</span>
            <img class="icon" v-if="curTimeType == ''" :src="rili" alt="">
            <img class="icon" v-else :src="rili2" alt="">
         </div>
          <div class="timeStr">{{selectTimeValue[0]}}~{{selectTimeValue[1]}}</div>
          <el-date-picker
            ref="dateSelect"
            class="date-picker"
            v-model="selectTimeValue"
            :type="elTimeType"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            v-show="true"
            >
          </el-date-picker>
      </div>
  </div>
</template>
<script>
export default {
  name: 'DayControlHegu',
  props: {
    timeType: {
      type: String,
      default: ""
    },
    timeValue: {
      type: Number,
      default: 0
    },
    // 是否两行显示
    isMini: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      //日期类型
      timeTypeArray: [
        {
          name: "当天",
          type: "hour"
        },
        {
          name: "当月",
          type: "day"
        },
        {
          name: "当年",
          type: "month"
        },
      ],
      curTimeType: this.timeType,
      curTimeValue: this.timeValue,
      start: null,
      end: null,
      selectTimeValue:[],
      elTimeType:'daterange'
    };
  },
  computed:{
    rili(){
        return  '/theme/default/img/rili.png'
    }, 
    rili2(){
        return  '/theme/default/img/rili2.png'
    }, 
  },
  watch:{
    timeType:{
      immediate:true,
      deep:true,
      handler:function(val){
        this.refreshType(val)
        // if(val=='month'){
        //   this.elTimeType='monthrange';
        // }
        // else{
        //   this.elTimeType='daterange';
        // }
      }
    },
    // curTimeType(val){
    //   if(val=='month'){
    //     this.elTimeType='monthrange';
    //   }else{
    //     this.elTimeType='daterange';
    //   }
    // },
    selectTimeValue(val){
      let params = this.getAreaTimeSearchParams3(this.config.area.areaType, this.config.area.areaCode, this.curTimeType, val )
      this.$emit("selected", params);
    }
  },
  methods: {
    refreshTime(){
      return new Promise(resolve =>{
        let params = this.getAreaTimeSearchParams3(this.config.area.areaType, this.config.area.areaCode, this.curTimeType,this.selectTimeValue)
        resolve(params)
      })
    },
    refreshType(type) {
      this.curTimeType = type;
      let params = this.getAreaTimeSearchParams3(this.config.area.areaType, this.config.area.areaCode, type)
      this.selectTimeValue = [params.startTime,params.endTime]
      // this.$emit("selected", params);
    },
    showDatePicker(){
      this.$refs.dateSelect.focus();
      this.curTimeType = ''
    },
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
// @import "~@/theme-default/src/mixin.scss";
.flex{
  display:flex;
  align-items: center;
}
.dayControl {
  width: 100%;
  display: flex;
  align-items: center;
  .line-box {
    display: flex;
    align-items: center;
    .cbtn {
      width: getWidth(40);
      height: getHeight(20);
      border-radius: px2rem(4);
      border: px2rem(1) solid #7DFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: getWidth(7);
      font-family:PingFangSC-Bold;
      font-size: px2rem(14);
      color: #7DFFFF;
    }
    .cbtn:hover {
      background: #7DFFFF;
      cursor: pointer;
      color: #002042;
    }

    .cbtnSelected {
      background: #7DFFFF;
      color: #002042;
    }
  }
  .timeLabel{
    position: relative;
    .icon-wrap{
      display: flex;
      justify-content: center;
      align-items: center;
      width: getWidth(60);
      height: getHeight(20);
      border-radius: px2rem(4);
      font-family:PingFangSC-Bold;
      font-size: px2rem(14);
      margin-right: getWidth(7);
      color: #7DFFFF;
      border: px2rem(1) solid #7DFFFF;
      .icon{
        width: getWidth(12);
        height: getWidth(12);
        margin-left: getWidth(7);
      }
    }
    .icon-wrap-active{
      background: #7DFFFF;
      color: #002042;
    }
    .timeStr{
      white-space: nowrap;
      font-family:PingFangSC-Bold;
      font-size: px2rem(14);
      color: #7DFFFF;
    }
  }
  .date-picker{
    position :absolute;
    z-index:1;
    opacity :0.01;
    left:0;
    width:100%;
    height :100%;
  }
}
.dayControl2{
  flex-direction: column;
  .line-box{
    .cbtn{
      width: getWidth(120);
      height: getHeight(35);
    }
    .cbtn:last-child{
      margin-right:0
    }
  }
  .timeLabel{
    width: 100%;
    margin-top:getHeight(10);
    .icon-wrap{
      width: getWidth(120);
      height: getHeight(35);
    }
  }
}
</style>
